import { Component } from '@angular/core';
import { CcdlLinkComponent } from '@cpm-pr1618001/ng-design-lib';

@Component({
  selector: 'cui-terms',
  imports: [CcdlLinkComponent],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
})
export class TermsComponent {}
